import { createContext } from 'react';
import { InsertUser, User } from '@/api-client/autogenerated';

interface ClientBillPositionTag {
  TagId: number;
  Name: string;
  Color: string | null;
}

interface ClientBillPosition {
  Id: number;
  BillId: string;
  Position: string;
  TagId: number | null;
  CreatedAt: string;
  UpdatedAt: string;
  Tag?: ClientBillPositionTag | null;
}

export interface ClientUser extends User {
  id: number;
  role?: string;
  liveToken?: string;
  BillPositions?: ClientBillPosition[];
  NewUser?: boolean;
}

interface AuthContextType {
  user: ClientUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  /** True if the user has a FullAccount relationship */
  isFullUser: boolean;
  login: (username: string, password: string) => Promise<ClientUser>;
  register: (params: InsertUser) => Promise<void>;
  logout: () => Promise<void>;
  requestPasswordReset: (usernameOrEmail: string) => Promise<void>;
  allowedStates: string[];
  refetchUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  isFullUser: false,
  login: async () => {
    throw new Error('Auth context not initialized');
  },
  register: async () => {
    throw new Error('Auth context not initialized');
  },
  logout: async () => {
    throw new Error('Auth context not initialized');
  },
  requestPasswordReset: async () => {
    throw new Error('Auth context not initialized');
  },
  allowedStates: [],
  refetchUser: async () => {
    throw new Error('Auth context not initialized');
  },
});
